/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Population or sample standard deviation?`)
};

const es_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Desviación estándar poblacional o muestral?`)
};

const de_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standardabweichung der Grundgesamtheit oder der Stichprobe?`)
};

const nl_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Populatie- of steekproefstandaardafwijking?`)
};

const fr_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart-type de population ou d'échantillon ?`)
};

const it_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deviazione standard di popolazione o campionaria?`)
};

const pt_br2_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvio padrão populacional ou amostral?`)
};

const pt_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desvio-padrão populacional ou amostral?`)
};

const ja_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`母標準偏差ですか、標本標準偏差ですか?`)
};

const zh_st_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是总体标准差还是样本标准差？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_faq_q3", locale)
	if (locale === "en") return en_st_faq_q3(inputs)
	if (locale === "es") return es_st_faq_q3(inputs)
	if (locale === "de") return de_st_faq_q3(inputs)
	if (locale === "nl") return nl_st_faq_q3(inputs)
	if (locale === "fr") return fr_st_faq_q3(inputs)
	if (locale === "it") return it_st_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_st_faq_q3(inputs)
	if (locale === "pt") return pt_st_faq_q3(inputs)
	if (locale === "ja") return ja_st_faq_q3(inputs)
	return zh_st_faq_q3(inputs)
};